<template>
  <div>
    <carousel :perPage="1">
      <slide class="map-bg">
        <h3>Redux</h3>
        <h4>
          <span class="def-guide">-/rēˈdəks,ˈrēˈdəks/</span>
          <span class="def-class">adjective</span> revived, revisited; <br/>
          <span class="def-class"> verb </span> to lead back
        </h4>
      </slide>
    </carousel>
    <b-row cols="1" cols-sm="12" cols-md="12" cols-lg="12">
      <b-col>

      </b-col>
    </b-row>
    <b-row cols="1" cols-sm="12" cols-md="12" cols-lg="12">
      <b-col lg="6" class="intro">
        <h3><strong>URBNRX</strong> provides data and research support to leaders and organizations that seek to:</h3>
        <ul>
          <li>Make more equitable decisions <em>that takes into account disparate impact</em></li>
          <li>Develop more comprehensive strategy <em>that addresses gaps and blindspots</em></li>
          <li>Practice accountability in a way <em>that builds the foundation for innovation</em></li>
        </ul>
      </b-col>
    </b-row>
  </div>
</template>

<script>
import { Carousel, Slide } from 'vue-carousel';

export default {
  data() {
    return {
      publicPath: process.env.BASE_URL,
    };
  },
  components: {
    Carousel,
    Slide,
  },
};
</script>
<style lang="scss">
  .map-bg{
    background-image: url("../../public/slides/map-bg.png");
    background-position: center;
  }
  h4{
    margin-bottom: 2rem;
  }
  p{
    margin-bottom: 2rem;
  }
  #footer{
    margin-top: 5rem;
  }
  .intro{
    padding: 2rem;
    ul{
      padding: 1.5rem;
    }
    h3{
      font-size: 1.25rem;
      margin-bottom: 0;
      padding: 0;
    }
    li{
      font-weight: bold;
      em{
        font-weight: normal;
      }
    }
  }
  .VueCarousel-slide{
    background-color: black;
    color: white;
    padding: 1rem;
  }
  .card{
    padding: 0rem;
    border-radius: 0;
    border: none;
  }
  .card-body{
    padding: .5rem;
  }
  .VueCarousel{
    margin-bottom: 1rem;
  }
  .card-header{
    font-weight: bold;
    background:none;
    border-bottom: 0.5pt dashed #ccc;
  }
  .def-guide{
    color:yellow;
    font-weight: normal;
    display: block;
  }
  .def-class{
    color:red;
  }
</style>
